<div class="ui-g-12">
  <app-error-messages [api_result]="this.payment_data.payment_start_api_result">
  </app-error-messages>
</div>
<ng-container *ngIf="this.payment_data.payment_start_api_result.Posting">
  <div class="ui-g-12">
    <h3>Fetching your order details...</h3>
    <app-loading type="LOADING_DATA"></app-loading>
  </div>
</ng-container>

<ng-container *ngIf="
    !this.payment_data.payment_start_api_result.Posting &&
    this.payment_data.payment_start_api_result.PromiseResult.success
  ">
  <div class="ui-g-12">
    <div class="ui-g-12">
      <div class="ui-g-12">
        <img class="img-responsive logo-img-payment" alt="eGlobalDoctors" [src]="this.logo_url" />
      </div>
      <div class="ui-g-12 ui-lg-6">
        <div class="ui-g-12">
          <h2>Payment Invoice</h2>
        </div>
        <div class="ui-g-12">
          <table class="table table-bordered" id="pdfcontent">
            <thead>
              <tr>
                <th class="ui-g-8">Description</th>
                <th class="ui-g-4">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="
                  let item of this.payment_data.order_data.basket.item_list
                ">
                <td class="ui-g-9">
                  {{ item.name }}
                </td>
                <td class="ui-g-3 notranslate">
                  {{item.rendered_amount}}
                </td>
              </tr>
              <tr>
                <td class="ui-g-6">
                  <h2>Total:</h2>
                </td>
                <td class="ui-g-6 egd-color notranslate">
                  <h2>
                    {{this.payment_data.order_data.basket.rendered_total}}
                  </h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="ui-g-12 ui-lg-6">
        <div class="ui-g-12" style="display: grid; justify-content: center !important">
          <h2>Payment Information</h2>
        </div>
        <ng-container *ngIf="this.payment_data.payment_start_api_result.Posting">
          <div class="ui-g-12">
            <app-loading type="LOADING_DATA"></app-loading>
          </div>
        </ng-container>
        <ng-container *ngIf="
            !this.payment_data.payment_start_api_result.Posting &&
            this.payment_data.payment_start_api_result.PromiseResult.success
          ">
          <div class="ui-g-12" style="display: grid; justify-content: center !important">
            <ng-container *ngIf="this.payment_data.is_paypal">
              <div id="dropin-container"></div>
              <button pButton pRipple name="pay_by_paypal" label="Continue to Payment" type="submit"
                [disabled]="isPosting()" (click)="payByPaypal()"></button>
            </ng-container>

            <ng-container *ngIf="this.payment_data.is_razorpay">
              <button pButton pRipple name="pay_by_razorpay" style="
                  width: 230px;
                  border-radius: 5px;
                  padding-top: 7px;
                  padding-bottom: 7px;
                " label="Continue to Payment" type="submit" [disabled]="isPosting()"
                (click)="payByRazorpay()"></button>
            </ng-container>
            <app-error-messages [api_result]="this.payment_data.payment_start_api_result">
            </app-error-messages>
            <div class="ui-g-12">
              {{ this.payment_data.order_data.basket.disclaimer }}
            </div>
          </div>
        </ng-container>
        <div class="ui-g-12">
          <app-error-messages [api_result]="this.payment_data.payment_start_api_result">
          </app-error-messages>

          <app-error-messages [api_result]="this.payment_data.transaction_submit_api_result">
          </app-error-messages>
        </div>
        <div class="ui-g-12">
          <app-loading class="ui-g-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER"></app-loading>
        </div>
      </div>
    </div>
  </div>
</ng-container>